module.exports = __webpack_public_path__ + "img/mobileladdercontrol3.8c09ba72.png";